module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app-layout', [_c('div', {
    slot: "header"
  }, [_c('v-sub-header', [_c('template', {
    slot: "header"
  }, [_vm._v("\n        Tarjoukset pyynnölle:\n      ")]), _vm._v(" "), _c('template', {
    slot: "subheader"
  }, [_c('h4', {
    staticClass: "m-t-05 m-b-1 tc-midnight-blue bold-link"
  }, [(_vm.$store.state.quote.current.quoteName && !_vm.loading) ? [_vm._v("\n            " + _vm._s(_vm.$store.state.quote.current.quoteName) + "\n          ")] : (!_vm.loading) ? [_vm._v("\n            Nimetön tarjouspyyntö\n          ")] : _vm._e()], 2)])], 2)], 1), _vm._v(" "), _c('v-bloc', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('v-vuetable-container', [_c('vuetable', {
    staticClass: "mg-md",
    attrs: {
      "css": _vm.css,
      "api-url": _vm.url + '/offers?quoteId=' + _vm.$store.state.route.params.quoteId,
      "fields": _vm.fields,
      "query-params": _vm.params,
      "no-data-template": _vm.noDataTemplate(this.loading, 'Ei saapuneita tarjouksia.')
    },
    on: {
      "vuetable:loaded": _vm.onLoading
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-sm btn-cal-poly-pomona-green pull-right disabled"
        }, [_vm._v("\n              Aloita neuvottelu\n            ")])]
      }
    }])
  }), _vm._v(" "), (_vm.loading) ? _c('v-spinner') : _vm._e()], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-444ba802"}!./src/app/pages/received-offers/received-offers.html
// module id = 475
// module chunks = 1